import { createContext, useContext, useEffect, useMemo, useState } from "react";

const TRANSLATIONS = {
  el: {
    // Nav
    "nav.dashboard": "Πίνακας",
    "nav.inventory": "Στόλος",
    "nav.addCar": "Νέο Αυτοκίνητο",
    "nav.brands": "Μάρκες & Μοντέλα",
    "nav.equipment": "Εξοπλισμός",
    "nav.users": "Χρήστες",
    "nav.exports": "Εξαγωγές",
    "nav.logout": "Αποσύνδεση",
    // Common
    "common.save": "Αποθήκευση",
    "common.cancel": "Ακύρωση",
    "common.delete": "Διαγραφή",
    "common.edit": "Επεξεργασία",
    "common.add": "Προσθήκη",
    "common.back": "Πίσω",
    "common.loading": "Φόρτωση...",
    "common.search": "Αναζήτηση",
    "common.actions": "Ενέργειες",
    "common.yes": "Ναι",
    "common.no": "Όχι",
    "common.greek": "Ελληνικά",
    "common.english": "English",
    "common.language": "Γλώσσα",
    "common.version": "Έκδοση",
    "common.date": "Ημερομηνία",
    // Dashboard
    "dash.totalCars": "Σύνολο Αυτοκινήτων",
    "dash.available": "Διαθέσιμα",
    "dash.reserved": "Κρατημένα",
    "dash.sold": "Πωλημένα",
    "dash.featured": "Προβεβλημένα",
    "dash.fleetValue": "Αξία Στόλου",
    "dash.inStock": "στο σύστημα",
    "dash.forSale": "προς πώληση",
    "dash.recent": "Πρόσφατες Καταχωρήσεις",
    "dash.viewAll": "Όλα τα οχήματα",
    "dash.emptyTitle": "Άδειος στόλος",
    "dash.emptySubtitle": "Καταχωρήστε το πρώτο σας αυτοκίνητο για να ξεκινήσετε.",
    "dash.addCar": "+ Προσθήκη Αυτοκινήτου",
    "dash.newCarTitle": "Νέο Αυτοκίνητο",
    "dash.newCarSub": "VIN ή Μάρκα/Μοντέλο",
    "dash.fleetTitle": "Στόλος",
    "dash.fleetSub": "Επεξεργασία & κατάσταση",
    "dash.exportTitle": "XML / JSON",
    "dash.exportSub": "car.gr · Google · WordPress",
    "dash.registration": "Καταχώρηση",
    "dash.management": "Διαχείριση",
    "dash.export": "Έξοδος",
    "dash.section": "Ενότητα",
    "dash.todayDate": "Σημερινή Ημερομηνία",
    // Car fields
    "car.brand": "Μάρκα",
    "car.model": "Μοντέλο",
    "car.variant": "Έκδοση",
    "car.year": "Έτος",
    "car.mileage": "Χιλιόμετρα",
    "car.price": "Τιμή",
    "car.fuel": "Καύσιμο",
    "car.transmission": "Κιβώτιο",
    "car.body": "Αμάξωμα",
    "car.engineCc": "Κυβισμός",
    "car.horsepower": "Ίπποι",
    "car.status": "Κατάσταση",
    "car.vehicle": "Όχημα",
    "car.photos": "Φωτογραφίες",
    "car.description": "Περιγραφή",
    "car.equipment": "Εξοπλισμός",
    "car.condition": "Κατάσταση Οχήματος",
    "car.color": "Χρώμα",
    "car.location": "Τοποθεσία",
    // Status badges
    "status.available": "Διαθέσιμο",
    "status.reserved": "Κρατημένο",
    "status.sold": "Πωλήθηκε",
    // Sidebar
    "sidebar.translation": "Αγγλική έκδοση",
    "sidebar.generateAI": "Δημιουργία με AI",
    "sidebar.translateTooltip": "Αυτόματη μετάφραση των πεδίων στα Αγγλικά",
  },
  en: {
    // Nav
    "nav.dashboard": "Dashboard",
    "nav.inventory": "Fleet",
    "nav.addCar": "New Vehicle",
    "nav.brands": "Brands & Models",
    "nav.equipment": "Equipment",
    "nav.users": "Users",
    "nav.exports": "Exports",
    "nav.logout": "Logout",
    // Common
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.back": "Back",
    "common.loading": "Loading...",
    "common.search": "Search",
    "common.actions": "Actions",
    "common.yes": "Yes",
    "common.no": "No",
    "common.greek": "Greek",
    "common.english": "English",
    "common.language": "Language",
    "common.version": "Version",
    "common.date": "Date",
    // Dashboard
    "dash.totalCars": "Total Vehicles",
    "dash.available": "Available",
    "dash.reserved": "Reserved",
    "dash.sold": "Sold",
    "dash.featured": "Featured",
    "dash.fleetValue": "Fleet Value",
    "dash.inStock": "in system",
    "dash.forSale": "for sale",
    "dash.recent": "Recent Listings",
    "dash.viewAll": "View all vehicles",
    "dash.emptyTitle": "Empty fleet",
    "dash.emptySubtitle": "Add your first vehicle to get started.",
    "dash.addCar": "+ Add Vehicle",
    "dash.newCarTitle": "New Vehicle",
    "dash.newCarSub": "VIN or Brand/Model",
    "dash.fleetTitle": "Fleet",
    "dash.fleetSub": "Edit & status",
    "dash.exportTitle": "XML / JSON",
    "dash.exportSub": "car.gr · Google · WordPress",
    "dash.registration": "Registration",
    "dash.management": "Management",
    "dash.export": "Export",
    "dash.section": "Section",
    "dash.todayDate": "Today",
    // Car fields
    "car.brand": "Brand",
    "car.model": "Model",
    "car.variant": "Variant",
    "car.year": "Year",
    "car.mileage": "Mileage",
    "car.price": "Price",
    "car.fuel": "Fuel",
    "car.transmission": "Transmission",
    "car.body": "Body Type",
    "car.engineCc": "Engine",
    "car.horsepower": "Horsepower",
    "car.status": "Status",
    "car.vehicle": "Vehicle",
    "car.photos": "Photos",
    "car.description": "Description",
    "car.equipment": "Equipment",
    "car.condition": "Condition",
    "car.color": "Color",
    "car.location": "Location",
    // Status badges
    "status.available": "Available",
    "status.reserved": "Reserved",
    "status.sold": "Sold",
    // Sidebar
    "sidebar.translation": "English version",
    "sidebar.generateAI": "Generate with AI",
    "sidebar.translateTooltip": "Auto-translate fields to English",
  },
};

const I18nContext = createContext({ lang: "el", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ui_lang") || "el");
  useEffect(() => {
    localStorage.setItem("ui_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const value = useMemo(() => {
    const t = (key) => (TRANSLATIONS[lang] || TRANSLATIONS.el)[key] || TRANSLATIONS.el[key] || key;
    return { lang, setLang: setLangState, t };
  }, [lang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
